import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { RxCross2 } from "react-icons/rx";
import { FaBarsStaggered } from "react-icons/fa6";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

 

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };



  useEffect(() => {
    if (window.innerWidth <= 992 && menuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    };
  }, [menuOpen]);

  return (
    <header className="nav-wrapper">
      <nav className="navbar_div">

    
        <div className="nav_logo">
          <img src="/vedastra_logo_bg.webp" alt="logo" loading="lazy" className="logo-cover-img" />
        </div>

    
        <ul className={menuOpen ? "nav-links active" : "nav-links"}>

          <li>
            <NavLink to="/" onClick={() => handleNavigate("/")}>
              Home
            </NavLink>
          </li>
            <li>
            <NavLink to="/about-us" onClick={() => handleNavigate("/about-us")}>
              About
            </NavLink>
          </li>

         <li>
            <NavLink to="/solutions" onClick={() => handleNavigate("/about-us")}>
              Solutions
            </NavLink>
          </li>
         

          <li>
            <NavLink to="/resources" onClick={() => handleNavigate("/resources")}>
              Resources
            </NavLink>
          </li>

          <li>
            <NavLink to="/careers" onClick={() => handleNavigate("/careers")}>
              Careers
            </NavLink>
          </li>

        

          <li className="mobile-btn">
            <button
              className="nav-btn"
              onClick={() => handleNavigate("/contact-us")}
            >
              Contact Us
            </button>
          </li>
        </ul>

        {/* RIGHT */}
        <div className="nav-right">
          <NavLink to="/contact-us" className="desktop-btn">
            <button className="nav-btn">Contact Us</button>
          </NavLink>

          <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <RxCross2 /> : <FaBarsStaggered />}
          </div>
        </div>

      </nav>
    </header>
  );
};

export default Navbar;